<script lang="ts">

  import httpClient from "$lib/axios-client"
  import { Card, CardContent, CardHeader, CardTitle } from "$lib/components/ui/card"
  import type { _response } from "$lib/data/type/_response"
  import type { CalendarDate } from "@internationalized/date"
  import { createQuery } from "@tanstack/svelte-query"

  let {
    salesId,
    date,
    prefix,
  }: {
    salesId: number
    date: CalendarDate
    prefix: string
  } = $props()

  type Recap = {
    plan_count: number
    plan_approved: number
    unplan_count: number
    unplan_approved: number
    real_count: number
    real_approved: number
  }

  const query = createQuery(() => ({
    queryKey: ["staff-activity", prefix, salesId, date.toString()],
    queryFn: async () => {
      const response = await httpClient.get<_response<Recap>>(`/api/${prefix}/staffs/${salesId}/activity-recap`, {
        params: {
          sales_id: salesId,
          date: date.toString()
        },
      })
      return response.data.result
    },
  }))

  const activityItems = $derived([
    { id: "plan", label: "Rencana", approved: query.data?.plan_approved, count: query.data?.plan_count },
    { id: "unplan", label: "Tdk Terencana", approved: query.data?.unplan_approved, count: query.data?.unplan_count },
    { id: "real", label: "Realisasi", approved: query.data?.real_approved, count: query.data?.real_count },
  ])

</script>

<div>
  <h3 class="mb-1 text-sm font-semibold">Aktifitas</h3>
  <div class="grid grid-cols-3 gap-2">
    {#each activityItems as item (item.id)}
      <Card class="gap-0 py-0 shadow-none">
        <CardHeader class="px-2 pt-2 pb-0">
          <CardTitle class="line-clamp-1 text-xs font-normal leading-none">
            {item.label}
          </CardTitle>
        </CardHeader>
        <CardContent class="px-2 pb-2 text-xl font-semibold tabular-nums tracking-tight">
          {query.isFetching ? "-" : `${item.approved ?? 0} / ${item.count ?? 0}`}
        </CardContent>
      </Card>
    {/each}
  </div>
</div>
